export class Risk {
    isRiskIncluded: string ='';
    discipline: string='';
    disciplineType: number=0;
    isDisciplineIncluded: boolean=false;
    riskNotes?: string='';
  }
  
  export class RiskTravel {
    travelExpenseForLocal?: string = '';
    travelExpenseForOther?: string= '';
    roundTripMileage?: string = '';
    discipline: string= '';
    disciplineType: number= 0;
    isDisciplineIncluded: boolean= false;
    siteLocationPopulated?: string= '';
  }
  
  export class CostReviewEnUsRisksSa {
    risks: Risk[] = new Array<Risk>();
    jobsiteWalkCompletedEquipment: number = 0;
    servicingOfficesHaveTechnical: number = 0;
    siteSpecificSafetyOrientation: number = 0;
    conditionsMeritAdditionalTime: number = 0;
    customerProvidingLaborEscorting: number = 0;
    providedLaborEscortsClearly: number = 0;
    siteDependenciesMeritAdditional: number = 0;
    coordinationWithOtherTrades: number = 0;
    extendedEquipmentShutDown: number = 0;
    energyOperationsManagerReview: number = 0;
    risksTravel: RiskTravel[] = new Array<RiskTravel>();
    deviceLocationToBeInspected: number = 0;
    overtimeOrPrevailingWage: string = '';
    certifiedPayrollReports: number = 0;
    equipmentAge: number = 0;
    environmentalCondition: number = 0;
    fireInspectionRequiresSiemens: number = 0;
    tapUtlizedInDelivery: number = 0;
    extendedWarrantyFee: string = '';
    mechanicalCocEngaged: number = 0;
    serviceDelieveryPlan: number = 0;
    afterHoursOrSeasonal: number = 0;
  }